<ng-container *ngIf="_likutWarehouse.buttonsAndText$ | async as buttonsAndText">
	<!-- global markup for header -->
	<header class="header">
		<div class="content">
			<div class="header__block row">
				<div class="header__arrow col image" (click)="handleNavigation()">
					<img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span>
				</div>
				<div class="header__title col">{{ buttonsAndText['date-range-pallet-movement-report'] | buttonText }}</div>
				<div class="header__burger col image">
					<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
				</div>
			</div>
		</div>
		<div class="report-table__row">
			<div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
				<form [formGroup]="form">
					<input
						class="header__search-input"
						type="text"
						[placeholder]="windowWidth > 768 ? 'חפש לפי שם/קוד פריט' : 'חפש'"
						formControlName="Search"
						id="search-Input"
						style="text-align: center; direction: rtl"
					/>
				</form>
				<button class="header__clear-icon" (click)="SearchClear()"></button>
			</div>
		</div>
	</header>

	<!-- start report table markup -->
	<section class="report-table">
		<div class="content">
			<div class="flex-row" style="margin-top: 100px">
				<div class="box">
					<b>סה"כ תנועות</b>
					<span>
						{{ totalAllPallets$ | async | toNormalNumber : 0 : true }}
					</span>
				</div>
				<div class="box">
					<button mat-raised-button color="primary" (click)="mustPickDatePopup = true">אפס</button>
				</div>
				<app-excel-button onlyEmit (clicked)="downloadExcel()"></app-excel-button>
			</div>
			<ng-container *ngIf="hasPickedAtLeastOnce">
				<div class="flex-row">
					<div class="box">
						<b>תקופה</b>
						<span>{{ form.controls.to.value | date : 'dd/MM/yyyy' }} - {{ form.controls.from.value | date : 'dd/MM/yyyy' }}</span>
					</div>
					<!-- </div>
				<div class="flex-row" > -->
					<form class="box" [formGroup]="form" dir="rtl">
						<mat-form-field style="font-size: 18px; text-align: start">
							<mat-label>{{ buttonsAndText['inventory-report-warehouse-select-label'] | buttonText }}</mat-label>
							<mat-select formControlName="warehouses" multiple>
								<mat-option *ngFor="let warehouse of warehouses$ | async" [value]="warehouse">
									{{ warehouse }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</form>
					<form class="box" [formGroup]="form" dir="rtl">
						<mat-form-field style="font-size: 18px; text-align: start">
							<mat-label>{{ buttonsAndText['date-range-pallet-movement-report-userID-select-label'] | buttonText }}</mat-label>
							<mat-select formControlName="users" multiple>
								<mat-option *ngFor="let user of users$ | async" [value]="user">
									{{ user }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</form>
				</div>
			</ng-container>

			<!-- <div class="flex-row">סינון סוכנים</div> -->

			<div class="report-table__row report-table__row_full-width" style="margin-right: 0px">
				<table class="report-table__table" cellspacing="0">
					<thead class="report-table__table-head">
						<tr>
							<th class="report-table__table-head-name" style="width: 60px">{{ buttonsAndText['date-range-pallet-movement-report-moveID-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 60px">{{ buttonsAndText['date-range-pallet-movement-report-count-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 80px">{{ buttonsAndText['date-range-pallet-movement-report-move-date-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 40px">{{ buttonsAndText['date-range-pallet-movement-report-warehouseID-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 40px">{{ buttonsAndText['date-range-pallet-movement-report-userID-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 60px">{{ buttonsAndText['date-range-pallet-movement-report-palletID-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 60px">{{ buttonsAndText['date-range-pallet-movement-report-productID-header'] | buttonText }}</th>
							<th class="report-table__table-head-name" style="width: 120px">{{ buttonsAndText['date-range-pallet-movement-report-product-name-header'] | buttonText }}</th>

							<!-- <th class="report-table__table-head-name sortable-clickable" (click)="sort('ProductId', 'Bizoim')" style="width: 100px">קוד</th> -->
						</tr>
					</thead>
					<tbody class="report-table__table-body">
						<tr *ngFor="let b of allPalletsDisplay$ | async" [ngClass]="{ 'valid-row': b.Count > 0, 'invalid-row': b.Count < 0 }">
							<td class="report-table__table-body-name">{{ b.MoveID }}</td>
							<td class="report-table__table-body-name">{{ b.Count | countToText }}</td>
							<td class="report-table__table-body-name">{{ b.MoveDate | appDate }}</td>
							<td class="report-table__table-body-name">{{ b.WarehouseID }}</td>
							<td class="report-table__table-body-name">{{ b.UserID }}</td>
							<td class="report-table__table-body-name">{{ b.PaletteID }}</td>
							<td class="report-table__table-body-name">{{ b.ProductId }}</td>
							<td class="report-table__table-body-name">{{ b.ProductName }}</td>
							<!-- <td class="report-table__table-body-name" style="word-break: break-all">{{ b.ProductId }}</td>
							<td class="report-table__table-body-name">{{ b.totqty | number : '1.0-2' }}</td>
							<td class="report-table__table-body-name">{{ b.totsum | number : '1.0-2' }}</td>
							<td class="report-table__table-body-name">{{ b.totsum / b.totqty | number : '1.0-2' }}</td> -->
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</section>
	<!-- end report table markup -->

	<div class="popup" *ngIf="mustPickDatePopup" style="z-index: 555">
		<div class="overlay"></div>
		<!-- <div class="product-detail__title" *ngIf="selectedTeudaToOpenPopup?.Client_Name">
			{{ selectedTeudaToOpenPopup?.Client_Name }}
		</div> -->
		<!-- <div class="product-detail__title remarks" *ngIf="remarks.length && !isRemarkPopupOpen"><button mat-raised-button color="primary" (click)="isRemarkPopupOpen=true;">הצג הערות</button></div> -->
		<div class="product-detail-popup popup__content">
			<div class="popup__close" (click)="handleClosePopup()" style="width: 30px; height: 30px; background-color: black"></div>
			<div class="product-detail__wrapper" *ngIf="!loadingMainQuery; else elseBlock">
				<h3 style="text-align: center">אנא בחר תקופה להציג</h3>

				<form [formGroup]="form" dir="rtl" (ngSubmit)="handleFormSubmit()" class="flex flex-column gap">
					<mat-form-field color="primary">
						<mat-label>תקופה</mat-label>
						<mat-error *ngIf="form.controls.from.invalid">תאריך אינו תקין</mat-error>
						<mat-date-range-input [rangePicker]="picker" [min]="dates.min" [max]="dates.max" (click)="picker.open()">
							<input matStartDate readonly="true" formControlName="from" />
							<input matEndDate readonly="true" formControlName="to" />
						</mat-date-range-input>
						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker></mat-date-range-picker>
					</mat-form-field>

					<div class="flex justify-evenly">
						<button mat-raised-button type="button" (click)="changeDateValue('month')">חודש</button>
						<button mat-raised-button type="button" (click)="changeDateValue('year')">שנה</button>
					</div>

					<button mat-raised-button color="primary" [disabled]="form.controls.to.invalid">בחר</button>
				</form>
			</div>
			<ng-template #elseBlock>
				<div class="product-detail__wrapper flex flex-column justify-align-center rtl">
					<h2>טוען, אנא המתינו...</h2>
					<mat-spinner diameter="50" color="primary"></mat-spinner>
				</div>
			</ng-template>
		</div>
	</div>
</ng-container>
